export const bookedByFilters = {
  any: 'Any',
  'Directful-GDS': 'Directful'
}
